export default "__VITE_ASSET__9ecc1747__"